import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./context/LanguageContext";
import Landing from "./pages/Landing";
import Admin from "./pages/Admin";
import Gallery from "./pages/Gallery";

function App() {
  return (
    <LanguageProvider>
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/galleria" element={<Gallery />} />
          <Route path="/area-soci" element={<Admin />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
